<template>
  <b-sidebar
    id="update-driver-sidebar"
    :visible="isEditDriver"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-edit-driver', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          Modifier chauffeur
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
        >
          <!-- Full Name -->
          <validation-provider
            #default="validationContext"
            name="name"
            rules="required"
          >
            <b-form-group
              label="chauffeur"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="driver.name"
                autofocus
                trim
                placeholder="chauffeur"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="cin"
            rules="required"
          >
            <b-form-group
              label="Cin"
              label-for="cin"
            >
              <b-form-input
                id="cin"
                v-model="driver.cin"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="cin"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider>
            <b-form-group
              label="camion"
              label-for="camion"
            >
              <validation-provider
                #default="{ errors }"
                name="camion"
              >
                <v-select
                  v-model="driver.truck"
                  :options="trucks"
                  :clearable="false"
                  label="serial_number"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Sauvegarder
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Annuler
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

export default {
  name: 'EditDriver',
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isEditDriver',
    event: 'update:is-edit-driver',
  },
  props: {
    isEditDriver: {
      type: Boolean,
      required: true,
    },
    currentDriver: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    ...mapGetters('truck', ['trucks']),
  },
  setup(props, { emit }) {
    const driver = ref(props.currentDriver)
    const onSubmit = async () => {
      const payload = {
        id: driver.value.id,
        name: driver.value.name,
        cin: driver.value.cin,
        truck: driver.value.truck.id,
      }
      store.dispatch('driver/updateDriver', payload)
      driver.value = props.currentDriver
      emit('update:is-edit-driver', false)
    }

    const { refFormObserver, getValidationState } = formValidation()

    return {
      driver,
      onSubmit,

      refFormObserver,
      getValidationState,
    }
  },
}
</script>

<style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";

  #add-new-user-sidebar {
    .vs__dropdown-menu {
      max-height: 200px !important;
    }
  }
</style>
